<!-- Zone 1 redesign (29/10/2026): two sample notifications show what the
     person will actually receive, which a bell and a sentence could not.
     The samples are drawn in HTML, not an image, so they follow the language. -->
<ion-content class="ion-padding">
  <div class="modal-content">
    <div class="flex flex-col gap-5">
      <smatchy-title mode="start" class="fc-sheet-title">{{ 'NOTIFICATION_MODALE.TITLE' | translate }}</smatchy-title>
      <p class="fc-subtitle">{{ 'NOTIFICATION_MODALE.DESCRIPTION_SHORT' | translate }}</p>

      <div class="samples" aria-hidden="true">
        <div class="sample">
          <span class="sample__icon"><img src="assets/icon/favicon.png" alt="" /></span>
          <div class="sample__body">
            <p class="sample__meta">Smatchy · {{ 'NOTIFICATION_MODALE.SAMPLE_NOW' | translate }}</p>
            <p class="sample__title">{{ 'NOTIFICATION_MODALE.SAMPLE_1_TITLE' | translate }}</p>
            <p class="sample__text">{{ 'NOTIFICATION_MODALE.SAMPLE_1_TEXT' | translate }}</p>
          </div>
        </div>
        <div class="sample sample--back">
          <span class="sample__icon"><img src="assets/icon/favicon.png" alt="" /></span>
          <div class="sample__body">
            <p class="sample__meta">Smatchy · {{ 'NOTIFICATION_MODALE.SAMPLE_LATER' | translate }}</p>
            <p class="sample__title">{{ 'NOTIFICATION_MODALE.SAMPLE_2_TITLE' | translate }}</p>
            <p class="sample__text">{{ 'NOTIFICATION_MODALE.SAMPLE_2_TEXT' | translate }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col">
      <ion-button expand="block" (click)="enableNotifications()">{{
        'NOTIFICATION_MODALE.BTN_TITLE' | translate
      }}</ion-button>
      <ion-button expand="block" fill="clear" class="later fc-quiet" (click)="dismiss()">{{
        'NOTIFICATION_MODALE.LATER' | translate
      }}</ion-button>
    </div>
  </div>
</ion-content>
